import { useRef, useState, useEffect, useCallback } from "react";
import api from "../../api";
import { Link, useHistory } from "react-router-dom";
import { checkPermissionStatus, generateMaskedPII } from "helpers/utils";
import { decryptDataFromArray } from "helpers/EncDec";
// import moment from "moment";
// import { getAuthToken } from "../../../../utils/commonMethods";
// import { getUserFormsAPI } from "./userFormAPI";

import delete_icon from "../../assets/images/icon/delete.svg";
import edit_icon from "../../assets/images/icon/edit.svg";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

export const FecthUserList = () => {
  const abortControllerRef = useRef(new AbortController());
  const { t } = useTranslation();
  const [userList, setUserList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUserList = useCallback(async () => {
    // let config = {
    //   headers: {
    //     Authorization: `Bearer ${getAuthToken()}`,
    //   },
    // };

    api
      .get(`${process.env.REACT_APP_API_URL}/admin/user/fetch-user`)
      .then(res => {
        let response = decryptDataFromArray(res.data);

        let { userList, success } = response;

        if (success) {
          setUserList(userList);
        }

        setIsLoading(false);
      })
      .catch(err => {
        setError(t(`Create User.No Users Available`));
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    const controller = abortControllerRef.current;
    fetchUserList();

    return () => {
      controller.abort();
    };
  }, [fetchUserList]);

  return { userList, isLoading, error };
};

export const GetUserListColumns = () => {
  let history = useHistory();
  const { t } = useTranslation();
  const handleUserDelete = userId => {
    if (
      window.confirm(
        t(`Create User.Are you sure you want to delete this User?`)
      )
    ) {
      api
        .delete(
          `${process.env.REACT_APP_API_URL}/admin/user/delete-user/${userId}`
        )
        .then(response => {
          let { success } = response.data;
          if (success) {
          toast.success("User deleted successfully");

          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
        })
        .catch(err => {
          console.log("Error while deleting the user list:::", err);
        });
    }
  };

  let resultArr = [
    {
      dataField: "role",
      text: t(`Create User.Role`),
      classes: "application-name po",
      headerClasses: "application-name po",
    },
    {
      dataField: "name",
      text: t(`Create User.Name`),
    },
    {
      dataField: "email",
      text: t(`Create User.Email`),
      formatter: (cell, row) => <>{generateMaskedPII(row?.email)}</>,
    },
    {
      dataField: "phone",
      text: t(`Create User.Mobile`),
      formatter: (cell, row) => <>{generateMaskedPII(row?.phone, 2)}</>,
    },
  ];

  if (checkPermissionStatus("user-list", "edit")) {
    resultArr.push({
      dataField: "id",
      text: t(`Create User.Actions`),
      formatter: cell => {
        return (
          <div className="d-flex gap-1 blue-icon-gap action-application">
            <div className="action-one small-img">
              <Link
                className="text-success blue-icon blue-color4"
                to={`/edit-user/${cell}`}
                title={t(`Create User.Edit User`)}
              >
                <img src={edit_icon} alt="edit_icon" />
                <span>{t(`Create User.Edit`)}</span>
              </Link>
            </div>

            {/* <Link className="text-success" to="#" title="Disapprove User">
              <i
                className="mdi mdi-thumb-up-outline font-size-18"
                id="edittooltip"
                style={{ color: "black" }}
              ></i>
            </Link> */}

            <div className="action-one small-img">
              <div
                onClick={() => handleUserDelete(cell)}
                className="text-success blue-icon blue-color3"
                style={{ cursor: "pointer" }}
                to="#"
                title={t(`Create User.Delete Record`)}
              >
                <img src={delete_icon} alt="delete_icon" />
                <span>{t(`Create User.Delete`)}</span>
              </div>
            </div>
          </div>
        );
      },
    });
  }

  return resultArr;
};
